
export * from '../../cookies-banner-web/__liferay__/index.js';
